import { Box, Flex, Text } from '@chakra-ui/react';
import DownloadButtons from '@/travo/components/ui/buttons/DownloadButtons';
import { Container, DisplayHeading, Eyebrow } from '@/travo/components/ui/postmark';
import { useCopy } from '@/travo/i18n';

const AboutCTA = () => {
  const { about } = useCopy();

  return (
    <Box as="section" id="download" bg="ink" color="paper">
      <Container py={{ base: '72px', md: '96px' }}>
        <Flex wrap="wrap" align="center" justify="space-between" gap="40px">
          <Flex direction="column" gap="18px" flex="1 1 480px" minW={0}>
            <Eyebrow color="sun">{about.ctaEyebrow}</Eyebrow>
            <DisplayHeading fontSize={{ base: '36px', md: '58px' }}>{about.ctaTitle}</DisplayHeading>
            <Text maxW="30em" color="sand">
              {about.ctaBody}
            </Text>
          </Flex>
          <DownloadButtons size={54} />
        </Flex>
      </Container>
      <Box className="airmail" h="10px" />
    </Box>
  );
};

export default AboutCTA;
